export default __webpack_public_path__ + "static/media/ds-fun-arit-js.2a466d5d.png";